<template>
    <dialog
        class="absolute inset-y-0 h-full flex max-w-[100vw] max-h-none m-0 p-0 border-0 bg-transparent text-inherit overflow-visible transition-transform duration-300"
        :class="[entry.drawerSide === DrawerSide.Left ? 'left-0' : 'left-full', drawerSizeClass]"
        :style="{ zIndex, transform }"
        :aria-hidden="isTopmost ? undefined : 'true'"
        :aria-label="entry.ariaLabel"
        :aria-labelledby="entry.ariaLabelledBy"
        :aria-modal="isTopmost ? 'true' : undefined"
        :data-drawer-side="entry.drawerSide"
        :data-entry-id="entry.id"
        :inert="isTopmost ? undefined : true"
        data-testid="drawer-panel"
        open
        tabindex="-1"
        @click.stop
    >
        <dynamic-entry-renderer :entry="entry" @close="$emit('entryClose')" />
    </dialog>
</template>

<script setup lang="ts">
    /**
     * Edge-anchored dialog panel for a dynamic drawer entry. It owns drawer
     * positioning, transform state, z-index, and topmost accessibility attributes.
     */
    import { computed } from 'vue';
    import DynamicEntryRenderer from '@/components/dynamicModals/DynamicEntryRenderer.vue';
    import { type ModalData } from '@/store/modules/dynamicModals/store.ts';
    import { DrawerSide, DrawerSize } from '@/store/modules/dynamicModals/types.ts';

    type Emits = (e: 'entryClose') => void;

    const props = defineProps<{
        entry: ModalData;
        isTopmost: boolean;
        transform: string;
        zIndex: string;
    }>();

    defineEmits<Emits>();

    const drawerSizeClass = computed(() =>
        props.entry.drawerSize === DrawerSize.Large ? 'w-[90%] sm:w-[600px]' : 'w-[90%] md:w-2/5'
    );
</script>
